import {
  type FilterWithPaginationStateShape,
  useFilterWithPagination,
} from '../../../../hooks/useFilterWithPagination';

const STATE_KEY = 'resellersTrialCreditsTableState';

export interface ResellersTrialCreditsFilterArguments {
  sort?: string;
}

export const DEFAULT_FILTER: ResellersTrialCreditsFilterArguments = {
  sort: 'id:asc',
};

export type ResellersTrialCreditsFilterWithPaginationShape =
  FilterWithPaginationStateShape<ResellersTrialCreditsFilterArguments>;

export const useResellersTrialCreditsFilterWithPagination = (): ResellersTrialCreditsFilterWithPaginationShape =>
  useFilterWithPagination(STATE_KEY, DEFAULT_FILTER);
